import { General } from './components/General.jsx'
import { AnnualLeave } from './components/AnnualLeave.jsx'
import { SickLeave } from './components/SickLeave.jsx'
import { EventList } from './components/EventList.jsx'

export const EventSettings = ({ settings, mappings, onSettingChange, onMappingChange, isSaving, integrationMode }) => {

  return (
    <>
      <General settings={settings} onSettingChange={onSettingChange} isSaving={isSaving} />
      <hr />
      <AnnualLeave settings={settings} onSettingChange={onSettingChange} isSaving={isSaving} />
      <hr />
      <SickLeave settings={settings} onSettingChange={onSettingChange} isSaving={isSaving} />
      <hr />
      <EventList mappings={mappings} onMappingChange={onMappingChange} integrationMode={integrationMode} />
    </>
  )
}
